module.exports = __webpack_public_path__ + "static/media/67.bdd1733e.jpg";